<template>
  <v-container fluid pa-0 ma-0>
    <v-flex grow pa-0 ma-0>
      <v-title>Create SIP Connections</v-title>
      <v-card>
        <v-card-text>
          <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
            <v-container fluid pa-0 ma-0>
              <v-title>Type of Connection</v-title>
              <v-layout row wrap>
                <v-flex xs3>
                  <vonex-radio
                    v-model="connectionType"
                    row
                    :value="'extension'"
                    name="connectionType"
                    rule="required"
                    @change="connectionChange"
                  >
                    <v-flex xs4>
                      <v-radio
                        label="SIP Extension (Via PBX)"
                        :value="'extension'"
                        color="primary"
                      ></v-radio>
                    </v-flex>
                    <v-flex xs4>
                      <v-radio
                        :label="`SIP Trunk`"
                        :value="'trunk'"
                        color="primary"
                      ></v-radio>
                    </v-flex>
                  </vonex-radio>
                </v-flex>

                <v-flex xs3 pt-3>
                  <v-layout wrap row>
                    <v-flex xs5>
                      <vonex-text
                        ref="txt"
                        v-model="NumberOfRows"
                        :label="
                          connectionType === 'extension'
                            ? 'Number of Extensions'
                            : 'Number of Channels'
                        "
                        type="number"
                        name="txt"
                        :min="1"
                        :rule="minNum"
                        :options="fieldConditions"
                        @keyup="changeRows"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <v-btn title="Add Row" class="iconBtn" @click="onAdd">
                        <v-icon>add</v-icon>
                      </v-btn>
                      <br />
                      <v-btn
                        title="Remove Row"
                        class="iconBtn"
                        @click="onRemove"
                      >
                        <v-icon>remove</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-spacer></v-spacer>
                <v-flex xs2>
                  <v-btn color="primary" @click="deleteSip(sip.sipId)">
                    Delete from {{ isQuote ? 'Quote' : 'Order' }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <table
                  class="table table table-striped table-bordered mobile-table"
                >
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th v-if="sip.connectionType === 'trunk'">Channels</th>
                      <th scope="col">Ext.</th>

                      <th scope="col">Contract Length (months)</th>
                      <th scope="col">
                        <div>Plan</div>
                        <div v-if="rows.length > 1">
                          <v-btn
                            color="primary"
                            small
                            round
                            title="copy down"
                            @click="copyDown('ratePlanID')"
                          >
                            Copy Down
                          </v-btn>
                        </div>
                      </th>
                      <th scope="col">
                        <div>ANI</div>
                        <div v-if="rows.length > 1">
                          <v-btn
                            color="primary"
                            small
                            round
                            title="copy down"
                            @click="copyDown('ani')"
                          >
                            Copy Down
                          </v-btn>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(extension, index) in rows" :key="index">
                      <td align="center">
                        <div v-show="extension.saved">
                          <v-icon color="green">check_circle</v-icon>
                          <v-icon @click="removeSipRow(index)">delete</v-icon>
                        </div>
                      </td>
                      <td v-if="sip.connectionType === 'trunk'">
                        <vonex-text
                          v-model="extension.quantity"
                          class="form-control custom-td"
                          :rule="'required|min_value:1'"
                          :name="'quantity' + index"
                          :options="fieldConditions"
                          hide-details
                        />
                      </td>
                      <td>
                        <vonex-text
                          v-model="extension.extension"
                          :options="fieldConditions"
                          class="form-control custom-td"
                          :rule="'required|numeric|maxNumber:7'"
                          :name="'Extension'"
                        />
                      </td>

                      <td>
                        <vonex-select
                          v-model="extension.contractLength"
                          :options="fieldConditions"
                          :items="loadContractSelection()"
                          hide-details
                          :rule="`contractMonths`"
                          :name="'contractTerm' + index"
                          :disabled="index > 0"
                          @change="copyDown('contractLength')"
                          class="custom-td"
                        ></vonex-select>
                      </td>
                      <td style="min-width: 80px">
                        <vonex-select
                          v-model="extension.ratePlanID"
                          :options="fieldConditions"
                          item-value="ratePlanID"
                          item-text="ratePlanDescription"
                          :items="validRatePlans(extension)"
                          :disabled="index > 0 && planType == 'mincharge'"
                          hide-details
                          class="form-control custom-td"
                          :rule="'required|planId'"
                          :name="'ratePlanID' + index"
                          @change="
                            index == 0 && planType == 'mincharge'
                              ? copyDown('ratePlanID')
                              : null
                          "
                        ></vonex-select>
                      </td>
                      <td>
                        <vonex-text
                          v-model="extension.ani"
                          class="form-control custom-td"
                          :name="'ani' + index"
                          :options="fieldConditions"
                          :rule="extension.ani ? 'phonenumber' : ''"
                          hide-details
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        :colspan="sip.connectionType === 'trunk' ? 4 : 3"
                        style="border: 0"
                      ></td>
                      <td align="right">Total: {{ total | currency }}</td>
                      <td align="right"></td>
                    </tr>
                  </tbody>
                </table>
                <p class="text-xs-right red--text d-block">For any 24mth Contract Terms selected, a 5% discount will apply. For any 36mth Contract Terms selected, a 10% discount will apply. Discount will show on the first bill and will discontinue at the end of the contract term.</p>
                <v-flex v-if="sip.connectionType == 'extension'" sm12>
                  <v-title>Hardware</v-title>
                  <v-layout row wrap>
                    <vonex-radio
                      v-model="sipHardware"
                      row
                      name="Hardware"
                      rule="required"
                    >
                      <v-flex xs4 md4 lg4>
                        <v-radio
                          :label="`ATA Required`"
                          :value="'ata'"
                          color="primary"
                        ></v-radio>
                      </v-flex>
                      <v-flex xs4 md4 lg4>
                        <v-radio
                          :label="`No Hardware`"
                          :value="'none'"
                          color="primary"
                        ></v-radio>
                      </v-flex>
                    </vonex-radio>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-flex sm12>
                <v-btn color="primary" name="sbmt" @click="save">
                  Save SIP
                </v-btn>
                <message-alert :component="message"></message-alert>
              </v-flex>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
import { createNamespacedHelpers, mapState, mapGetters } from 'vuex';
import {
  mapSipFields,
  mapSipMultiRowFields,
  mapRatePlanMultiRowFields,
} from '../store/modules/orders';
const { mapActions: mapSipActions, mapMutations: mapSipMutations } =
  createNamespacedHelpers(`orders/Sip`);
import Utils from '@/mixins/utils.mixin';

export default {
  name: 'CreateSip',
  mixins: [Utils],
  data() {
    return {
      NumberOfRows: 1,
      planType: 'capped',
      sipHardware: null,
    };
  },
  computed: {
    ...mapSipMultiRowFields({ rows: 'sip.sipRows' }),
    ...mapRatePlanMultiRowFields({ ratePlans: 'rows' }),
    ...mapSipFields(['sip', 'message']),
    ...mapSipFields({ connectionType: 'sip.connectionType' }),
    ...mapGetters('orders', [
      'isQantas',
      'isResidential',
      'isQuote',
      'hasNoDDProvided',
    ]),
    minNum: function () {
      return this.sip.connectionType == 'trunk'
        ? 'min_value:1'
        : this.planType == 'capped'
        ? 'min_value:1'
        : 'min_value:1';
    },
    total: function () {
      try {
        if (this.planType === 'mincharge')
          return this.ratePlans.filter(
            (e) => e.ratePlanID == this.rows[0].ratePlanID
          )[0].monthlyRetail;
        else {
          let newrows = this.rows
            .map(
              (x) =>
                this.ratePlans.filter((e) => e.ratePlanID == x.ratePlanID)[0]
                  .monthlyRetail *
                (this.sip.connectionType == 'extension' ? 1 : x.quantity)
            )
            .reduce((prev, next) => prev + next);
          return newrows;
        }
      } catch (err) {
        return 0;
      }
    },
  },
  mounted() {
    let vm = this;
    vm.sipHardware = vm.sip.hardware;
    vm.populateSips()
      .then((data) => {
        if (data) {
          if (data.sipRows) {
            if (data.connectionType === 'trunk')
              vm.NumberOfRows = data.sipRows[0].quantity;
            else vm.NumberOfRows = data.sipRows.length;
          }

          if (data.sipRows[0].ratePlanID) {
            const rowRatePlan = vm.ratePlans.find((rate) => {
              return rate.ratePlanID === data.sipRows[0].ratePlanID;
            });
            // if (rowRatePlan.mixnMatch === false) vm.planType = "mincharge";
            //Removed for now, pending review with Dallas?
          }
        }
      })
      .catch((err) => {
        vm.setMessage({
          message: 'Unable to retreive: ' + err.message,
          httpStatus: 500,
        });
      });
  },
  methods: {
    ...mapSipActions([
      'updateRows',
      'removeRows',
      'populateSips',
      'setMessage',
      'removeHardware',
      'removeSipFromOrder',
    ]),
    ...mapSipMutations(['addRow', 'changeQuantity', 'removeSipRow', 'setSip']),
    connectionChange: function () {
      let vm = this;

      if (vm.sip.connectionType == 'trunk' && vm.rows.length > 1) {
        if (!vm.rows[0].saved)
          vm.$dialog
            .confirm('Switching to Trunk will delete rows, are you sure?')
            .then(function () {
              vm.removeRows(1).then(function () {
                vm.changeQuantity(vm.rows.length);
                vm.removeHardware();
                vm.NumberOfRows = vm.rows.length;
              });
            })
            .catch(function () {
              vm.NumberOfRows = vm.rows.length;
              return;
            });
        else {
          vm.removeRows(1).then(() => {
            vm.changeQuantity(vm.rows.length);
            vm.removeHardware();
            vm.NumberOfRows = vm.rows.length;
          });
        }
      }
      if (vm.sip.connectionType == 'trunk') {
        if (vm.rows.length < 1) {
          vm.changeQuantity(2);
          vm.removeHardware();
          vm.NumberOfRows = 1;
        } else {
          vm.changeQuantity(vm.rows.length);
          vm.removeHardware();
          vm.NumberOfRows = vm.rows.length;
        }
      }
      if (vm.sip.connectionType == 'extension' && vm.sip.sipRows.length < 2) {
        vm.NumberOfRows = 2;
        vm.changeRows();
      }
      // if (vm.sip.connectionType == "trunk" && vm.rows.length < 2) {
      //   for (let i = vm.s NumberOfRows; i < 2; i++) vm.addRow();
      //   vm.NumberOfRow= 2;
      // }
    },
    changeRows: function () {
      let vm = this;
      var oldVal = 0 || vm.rows.length;
      var newVal = vm.NumberOfRows;
      if (parseInt(oldVal, 10) > parseInt(newVal, 10)) {
        vm.$dialog
          .confirm('You are about to delete rows, are you sure?')
          .then(function () {
            vm.removeRows(newVal).then(function () {
              vm.NumberOfRows = vm.rows.length;
              vm.changeQuantity(vm.rows.length);
            });
          })
          .catch(function () {
            vm.NumberOfRows = oldVal;
            vm.changeQuantity(vm.rows.length);
            return;
          });
      } else {
        if (newVal > vm.rows.length) {
          if(vm.sip.connectionType === 'trunk')
            this.changeQuantity(this.NumberOfRows);
          for (var i = oldVal; i < newVal; i++) {
            if (vm.sip.connectionType === 'extension') {
              vm.addRow(vm.rows[0] ? vm.rows[0].contractLength : null);
              vm.rows[i].extension = 500 + i;
            }
          }
        }
      }
    },
    onAdd() {
      this.NumberOfRows++;
      if (this.sip.connectionType === 'trunk') {
        this.changeQuantity(this.sip.sipRows[0].quantity + 1);
      }
      this.$refs.txt.$emit('keyup');
    },
    onRemove() {
      this.NumberOfRows--;
      if (this.sip.connectionType === 'trunk') {
        this.changeQuantity(this.sip.sipRows[0].quantity - 1);
      }
      this.$refs.txt.$emit('keyup');
    },
    checkPlan: function (ratePlan) {
      return ratePlan.usageType === 'SIP';
    },
    validRatePlans: function (months) {
      if(months.contractLength == null) return null;
      return this.ratePlans
        .filter((x) => !x.archived)
        // .filter((x) => x.qantas === this.isQantas)
        .filter((x) => x.residential === this.isResidential)
        .filter(this.checkPlan)
        .filter((x) => !x.ratePlanDescription.toLowerCase().includes('teams'))
        .filter((e) => {
          // If Plans with Handset Rental: only show grenkeFinance plans
          if (this.isQantas) {
            return e.grenkeFinance === true;
          }
          // If not Plans with Handset Rental: exclude grenkeFinance plans
          if (!this.isQantas && e.grenkeFinance === true) {
            return false;
          }
          return true;
        })
        .filter((m) => {
          return m.contractMonths == months.contractLength;
        });
    },
    copyDown: function (column) {
      let vm = this;
      for (var i = 1; i < vm.rows.length; i++) {
        vm.rows[i][column] = vm.rows[0][column];
      }
      return;
    },
    deleteRow(index) {
      let rows = this.rows.filter(
        (x) => x.extension != this.rows[index].extension
      );
      if (rows.length > 0) {
        this.updateRows().then(() => {
          this.NumberOfRows = this.rows.length;
        });
      }
    },
    deleteSip(sipId) {
      let vm = this;

      this.$dialog
        .confirm(
          'You are about to delete SIP from this order, this cannot be undone, are you sure?'
        )
        .then(() => {
          vm.removeSipFromOrder(sipId).then(() => {
            vm.$router.push('order-summary');
          });
        });
    },
    async save() {
      let vm = this;
      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (result) {
            try {
              let data = vm.rows.map((x) => x.ratePlanID);
              if (data.includes(0))
                return vm.setMessage({
                  message: 'Unable to save: Check empty fields above',
                  httpStatus: 500,
                });
              await vm.updateRows();
            } catch (err) {
              vm.setMessage({
                message: 'Unable to save: ' + err.message,
                httpStatus: 500,
              });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
            }
          })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    loadContractSelection() {
      let vm = this;
      let contract = [{ text: '0 months', value: 0 }];

      if (vm.hasNoDDProvided && !vm.isQuote) {
        return contract;
      }
      const defaultMonths = [12, 36];
  
      defaultMonths.forEach(months => {
        let hasMonths = this.ratePlans
          .filter((x) => x.usageType == "SIP" && (!this.isResidential || x.residential))
          .some((plan) => plan.contractMonths === months);
        
        if (hasMonths) {
          contract.push({
            text: `${months} months`,
            value: months,
          });
        }
      });

      return contract;
    }
  },
  watch: {
    sipHardware(val) {
      let vm = this;
      vm.setSip({ ...vm.sip, hardware: val });
      return val;
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/custom-styles.scss';
</style>
